import * as React from 'react';
import {useState} from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { ArrowRightAlt, ChecklistRtl, ChevronLeft, ChevronRight, EditCalendarOutlined, EmojiEvents, EmojiEventsOutlined, FormatListBulleted, FormatListNumbered, History, HomeOutlined, ImportExport, LandscapeOutlined, ManageSearchOutlined } from '@mui/icons-material';
import { border, borderBottom } from '@mui/system';
import { SwipeableDrawer } from '@mui/material';
import { 
  List, 
  ListItemButton, 
  ListItemIcon, 
  ListItemText, 
  Collapse, 
  Divider 
} from '@mui/material';
import {
  Inbox as InboxIcon,
  ExpandLess,
  ExpandMore,
  StarBorder,
  Settings as SettingsIcon,
  Person as PersonIcon,
  Help as HelpIcon
} from '@mui/icons-material';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';

const NAV_BAR_HEIGHT = 56;

export default function SimpleBottomNavigation() {
  const [value, setValue] = React.useState(0);
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  // const navigate = useNavigate();

  // React.useEffect(() => {
  //   if(value === 'home') {
  //     navigate('/Home')
  //   }
  //   else if(value === 'schedule') {
  //     navigate('/Schedule')
  //   }
  //   else if(value === 'items') {
  //     navigate('/Tasks')
  //   }
  //   else if(value === 'actions') {
  //     navigate('/Planning/Yearly/This_Year')
  //   }
  //   else if(value === 'favourites') {
  //     navigate('/Tasks')
  //   }
  // }, [value]);

    // Store the open/closed state of menus using their text/id as keys
  const [openMenus, setOpenMenus] = useState({});

  // Clean toggle handler that supports multiple independent dropdowns
  const handleToggle = (menuKey) => {
    setOpenMenus((prev) => ({
      ...prev,
      [menuKey]: !prev[menuKey],
    }));
  };

  const styles = {
    navMenu: {
      border: 'rgba(128, 128, 128, 0.5)',
      borderTop: 'none', 
      borderBottom: 'none', 
      boxShadow: 'none',
      maskImage: 'linear-gradient(to bottom, transparent 0%, black 23px)',
      WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, black 23px)', // Safari support
      backgroundColor: 'rgba(10, 10, 10, 0.71)',
      backdropFilter: 'blur(5px)',
      position: 'fixed',
      bottom: -3,
      left: 0,
      right: 0,      
    },
    navButton: {
      color: 'rgba(138, 138, 138, 1)',
    }
  };
  
  return (
    <Box sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, }} elevation={3}>
      <BottomNavigation sx={styles.navMenu} showLabels
        value={value}
        onChange={(event, newValue) => {setValue(newValue);
          }
        }>
        <BottomNavigationAction label="Home" icon={<HomeOutlined />} component={Link} to="/Home"
        sx={styles.navButton} />
        <BottomNavigationAction label="Schedule" value='schedule' icon={<FormatListNumbered />} component={Link} to="/Schedule" 
        sx={styles.navButton} />
        <BottomNavigationAction label="Items" value='items' icon={<FormatListBulleted />} component={Link} to="/Tasks" 
        sx={styles.navButton} />
        <BottomNavigationAction label="Actions" value='actions' icon={< ArrowRightAlt/>} component={Link} to="/Planning/Yearly/This_Year" 
        sx={styles.navButton} />
        {/* <BottomNavigationAction label="Favourites" value='favourites' icon={<Star />} component={Link} to="/home" /> */}
      </BottomNavigation>

      <SwipeableDrawer
        anchor="bottom"
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        onOpen={() => setIsDrawerOpen(true)}
        swipeAreaWidth={15} // The swipe zone matches the exact height of the navbar
        disableDiscovery={false}
        sx={{
          zIndex: 11, // High z-index places it ON TOP of the navigation bar
          '& .MuiDrawer-paper': {
            height: '67%', 
            overflow: 'visible',
            backgroundColor: isDrawerOpen ? '#ffffff' : 'transparent', // Transparent when closed to show navbar underneath
            boxShadow: isDrawerOpen ? undefined : 'none',
            // Pushes the drawer fully below the view when closed
            transform: isDrawerOpen 
              ? 'translateY(0px) !important' 
              : `translateY(100%) !important`,
            transition: 'transform 0.3s ease-in-out, background-color 0.2s !important',
            borderRadius: '12px'
          },
        }}
      >
        {/* INTERACTIVE HANDLE OVERLAY LAYER */}
        {/* When the drawer is closed, this invisible/subtle overlay catches the user's upward swipes directly over the navigation bar */}
        {!isDrawerOpen && (
          <Box
            sx={{
              position: 'absolute',
              top: -NAV_BAR_HEIGHT, // Aligns perfectly on top of the navbar bounds
              left: 0,
              right: 0,
              height: NAV_BAR_HEIGHT,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-start',
              pt: 0.5,
              cursor: 'ns-resize',
              pointerEvents: 'auto', // Catches the touch events
            }}
            onClick={() => setIsDrawerOpen(true)}
          >
            {/* Small subtle visual line overlaid right at the top edge of the navbar */}
            <Box sx={{ width: 36, height: 4, backgroundColor: 'rgba(0,0,0,0.2)', borderRadius: 2 }} />
          </Box>
        )}

        {/* DRAWER INNER CONTENT */}
        <Box sx={{ p: 3, pt: 4, bgcolor: '#c5c5c5', height: '100%', overflowY: 'auto', borderRadius: 3}}>
          <h3>Thaelos Main Navigation Menu</h3>
          {/* Your list items go here */}
                    <Sidebar  collapsed={false} collapsedWidth="70px" width="100%" rootStyles={{
                      
                      overflowY: 'auto', // Enables vertical scrolling for long menus
                      overflowX: 'hidden', // Prevents horizontal scrollbars
                      maxHeight: '100vh',
                      borderRadius: '7px'
                      
                      }}>
                      <Menu>
                        <MenuItem icon={<HomeOutlined/>} component={<Link to="/Home" />}>Home</MenuItem>
                        {/* <MenuItem>Dashboard </MenuItem> */}
                        
                        <SubMenu icon={<FormatListNumbered/>} label="Schedule">
                          <MenuItem component={<Link to="/Schedule" />}>Today</MenuItem>
                          <MenuItem>Tomorrow</MenuItem>
                          <MenuItem>This Week</MenuItem>
                          {/* <MenuItem>Next Week</MenuItem>
                          <MenuItem>This Month</MenuItem> */}
                        </SubMenu>
                      </Menu>
                    </Sidebar>
                    <Divider sx={{ my: 1 }} />
                    <Sidebar collapsed={false} collapsedWidth="70px" width="100%" rootStyles={{
                      overflowY: 'auto', // Enables vertical scrolling for long menus
                      overflowX: 'hidden', // Prevents horizontal scrollbars
                      maxHeight: '100vh',
                      borderRadius: '7px'
                      }}>
                      <Menu label="Goals & Tasks">
                        {/* <MenuItem>Overdue </MenuItem> */}
                        <MenuItem icon={<EmojiEventsOutlined/>} component={<Link to="/Goals" />}>Goals</MenuItem>              
                        <SubMenu icon={<ChecklistRtl/>} label="Tasks">              
                          <MenuItem component={<Link to="/Tasks" />}>All</MenuItem>
                          <SubMenu label="New" component={<Link to="/Tasks/New" />}>
                            <MenuItem component={<Link to="/Tasks/New" />}>Captured </MenuItem>
                            {/* <MenuItem>Assigned </MenuItem> */}
                          </SubMenu>
                          <MenuItem component={<Link to="/Tasks/Processing" />}>Processing</MenuItem>
                          <SubMenu label="Ready" component={<Link to="/Tasks/Ready" />}>              
                            <MenuItem>Today</MenuItem>
                            <MenuItem>Tomorrow</MenuItem>
                            <MenuItem>This Week</MenuItem>
                            <MenuItem>Next Week</MenuItem>
                            <MenuItem>This Month</MenuItem>
                          </SubMenu>
                          <MenuItem component={<Link to="/Tasks/Scheduled" />}>Scheduled</MenuItem>
                          <MenuItem component={<Link to="/Tasks/In_Progress" />}>In Progress</MenuItem>
                        </SubMenu>
                        <MenuItem icon={<History/>} component={<Link to="/Tasks/Recent" />}>Recent</MenuItem>
                        {/* <MenuItem>Recent </MenuItem> */}
                      </Menu>
                      {/* <p/> */}
                    </Sidebar>
                    <Divider sx={{ my: 1 }} />
                    <Sidebar  collapsed={false} collapsedWidth="70px" width="100%" rootStyles={{

                      overflowY: 'auto', // Enables vertical scrolling for long menus
                      overflowX: 'hidden', // Prevents horizontal scrollbars
                      maxHeight: '100vh',
                      borderRadius: '7px'
                      
                      }}>
                      <Menu>
                        <SubMenu icon={<LandscapeOutlined/>} label="Planning">
                          <SubMenu  label="Yearly">
                            <MenuItem component={<Link to="/Planning/Yearly/This_Year" />}>This Year</MenuItem>
                            <MenuItem component={<Link to="/Planning/Yearly/Next_Year" />}>Next Year</MenuItem>
                            <MenuItem component={<Link to="/Planning/Yearly/Year-Hence" />}>Year-Hence</MenuItem>
                          </SubMenu>
                          <SubMenu  label="Quarterly">
                            <MenuItem component={<Link to="/Planning/Quarterly/This_Quarter" />}>This Quarter</MenuItem>
                            <MenuItem component={<Link to="/Planning/Quarterly/Next_Quarter" />}>Next Quarter</MenuItem>
                            <MenuItem component={<Link to="/Planning/Quarterly/Quarter-Hence" />}>Quarter-Hence</MenuItem>
                          </SubMenu>
                          <SubMenu  label="Monthly">
                            <MenuItem component={<Link to="/Planning/Monthly/This_Month" />}>This Month</MenuItem>
                            <MenuItem component={<Link to="/Planning/Monthly/Next_Month" />}>Next Month</MenuItem>
                            <MenuItem component={<Link to="/Planning/Monthly/Month-Hence" />}>Month-Hence</MenuItem>
                          </SubMenu>
                          <SubMenu  label="Weekly">
                            <MenuItem component={<Link to="/Planning/Weekly/This_Week" />}>This Week</MenuItem>
                            <MenuItem component={<Link to="/Planning/Weekly/Next_Week" />}>Next Week</MenuItem>
                            <MenuItem component={<Link to="/Planning/Weekly/Week-Hence" />}>Week-Hence</MenuItem>
                          </SubMenu>
                        </SubMenu>
                        <SubMenu  icon={<EditCalendarOutlined/>} label="Scheduling">
                          <MenuItem component={<Link to="/Scheduling/Today" />}>Today</MenuItem>
                          <MenuItem component={<Link to="/Scheduling/Tomorrow" />}>Tomorrow</MenuItem>
                          <MenuItem component={<Link to="/Scheduling/Next_Three_Days" />}>Next Three Days</MenuItem>
                          <MenuItem component={<Link to="/Scheduling/This_Week" />}>This Week</MenuItem>
                          <MenuItem component={<Link to="/Scheduling/Next_Week" />}>Next Week</MenuItem>
                          <MenuItem component={<Link to="/Scheduling/Week-Hence" />}> Week-Hence</MenuItem>
                          <MenuItem component={<Link to="/Scheduling/This_Month" />}>This Month</MenuItem>
                          <MenuItem component={<Link to="/Scheduling/Month-Hence" />}>Month-Hence</MenuItem>
                        </SubMenu>
                        <SubMenu icon={<ManageSearchOutlined/>} label="Review">
                          <MenuItem component={<Link to="/Review/Daily" />}>Daily</MenuItem>
                          <MenuItem component={<Link to="/Review/Weekly" />}>Weekly</MenuItem>
                          <MenuItem component={<Link to="/Review/Monthly" />}>Monthly</MenuItem>
                          <MenuItem component={<Link to="/Review/Quarterly" />}>Quarterly</MenuItem>
                          <MenuItem component={<Link to="/Review/Yearly" />}>Yearly</MenuItem>
                        </SubMenu>              
                        {/* <MenuItem>Search</MenuItem> */}
                      </Menu>
                    </Sidebar>
                    {/* <Sidebar collapsed={navMenuCollapsed} collapsedWidth="50px" width="175px">
                      <Menu>
                        <SubMenu label="Projects">
                          <MenuItem>Recent </MenuItem>
                        </SubMenu>
                        <SubMenu label="Systems">
                        <MenuItem>Strength & Fitness </MenuItem>
                          <MenuItem>Nutrition </MenuItem>
                          <MenuItem>Cleaning </MenuItem>
                          <MenuItem>Maintenance </MenuItem>
                          </SubMenu>
                          <MenuItem>Filters & Labels </MenuItem>
                        <MenuItem>Templates </MenuItem>
                        </Menu>
                    </Sidebar> */}
                    <p/>
                    <Sidebar collapsed={false} collapsedWidth="70px" width="100%" rootStyles={{
                      
                      overflowY: 'auto', // Enables vertical scrolling for long menus
                      overflowX: 'hidden', // Prevents horizontal scrollbars
                      maxHeight: '100vh',
                      borderRadius: '7px',
                      height: '125px'
                          
                    }}>
                      {/* <Menu>               */}
                        {/* <MenuItem>Automation </MenuItem>
                        <MenuItem>Collaboration </MenuItem>
                        <MenuItem>Analytics </MenuItem>
                        <MenuItem>Wiki </MenuItem>
                        <MenuItem>History </MenuItem> */}
                        {/*TODO: Update these to handle no items/ensure they can handle undefined 'items'*/}
                        {/* <SubMenu icon={<ImportExport/>} label="Data"> */}
                          {/* <MenuItem icon={<ImportExport/>}><ImportExportDataPanel items={items} setItems={setItems}/> </MenuItem>
                          <MenuItem icon={<CloudSyncOutlined/>}><CloudDataPanel items={items} setItems={setItems} firebaseApp/> </MenuItem> */}
                          {/* <MenuItem><ImportExportDataPanel items={items} setItems={setItems}/> </MenuItem> */}
                          {/* <MenuItem><CloudDataPanel items={items} setItems={setItems} firebaseApp/> </MenuItem> */}
                        {/* </SubMenu> */}
                      {/* </Menu> */}
                    </Sidebar>
              <List
      sx={{ 
        display: 'none',
        width: '100%', 
        maxWidth: 360, 
        bgcolor: 'background.paper',
        borderRadius: 2,
        boxShadow: 1
      }}
      component="nav"
    >
      <ListItemButton component={Link} to="/Home">
        <ListItemIcon>
          <HomeOutlined></HomeOutlined>
        </ListItemIcon>
        <ListItemText primary="Home" />
      </ListItemButton>

      {/* SECTION 1: COLLAPSIBLE DROPDOWN */}
      <ListItemButton onClick={() => handleToggle('mail')}>
        <ListItemIcon>
          <EmojiEvents></EmojiEvents>
        </ListItemIcon>
        <ListItemText primary="Schedule" />
        {openMenus['mail'] ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      <Collapse in={openMenus['mail']} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon>
              <StarBorder />
            </ListItemIcon>
            <ListItemText primary="Starred" />
          </ListItemButton>
          
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon>
              <StarBorder />
            </ListItemIcon>
            <ListItemText primary="Archived" />
          </ListItemButton>
        </List>
      </Collapse>

      <ListItemButton onClick={() => handleToggle('items')}>
        <ListItemIcon>
          <EmojiEvents></EmojiEvents>
        </ListItemIcon>
        <ListItemText primary="Items" />
        {openMenus['items'] ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      <Collapse in={openMenus['items']} timeout="auto" unmountOnExit>
        <ListItemButton sx={{ pl: 4 }}
                        component={Link} to="/Goals">
          <ListItemIcon>
            <EmojiEvents></EmojiEvents>
          </ListItemIcon>
          <ListItemText primary="Goals" />
        </ListItemButton>
      </Collapse>

      <ListItemButton onClick={() => handleToggle('mail')}>
        <ListItemIcon>
          <InboxIcon />
        </ListItemIcon>
        <ListItemText primary="Inbox Messages" />
        {openMenus['mail'] ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      <Divider sx={{ my: 1 }} />

      {/* SECTION 2: COLLAPSIBLE DROPDOWN */}
      <ListItemButton onClick={() => handleToggle('account')}>
        <ListItemIcon>
          <SettingsIcon />
        </ListItemIcon>
        <ListItemText primary="Account Settings" />
        {openMenus['account'] ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      <Collapse in={openMenus['account']} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton 
            component={Link} 
            to="/Tasks"
            sx={{ pl: 4 }}
            >
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            <ListItemText primary="Profile Details" />
          </ListItemButton>
        </List>
      </Collapse>

      <Divider sx={{ my: 1 }} />

      {/* SECTION 3: STANDARD FLAT LINK (NO DROPDOWN) */}
      <ListItemButton>
        <ListItemIcon>
          <HelpIcon />
        </ListItemIcon>
        <ListItemText primary="Help & Support" />
      </ListItemButton>
    </List>
        </Box>
      </SwipeableDrawer>
    </Box>
  );
}